// NGF-6504: OffersSlim and OffersSlimContentContractForPageTemplate have been extracted to the shared
// @cx-web/components package (packages/components/page-template/OffersSlim/) so both RR7 atlas and
// atlas-astro share a single implementation. This file re-exports the shared wrapper with the RR7-
// specific Sentry `onError` handler pre-wired, so existing callers in component-map.tsx remain unchanged.
//
// The extraction mirrors the OffersList precedent (NGF-6397). The shared wrapper accepts an `onError`
// prop instead of importing @sentry/react-router directly.
import {
  OffersSlim as SharedOffersSlim,
  OffersSlimContentContractForPageTemplate,
  type OffersSlimProps,
} from '@cx-web/components/page-template/OffersSlim';
import { captureException } from '@sentry/react-router';

export { OffersSlimContentContractForPageTemplate };

const onError = (error: unknown) => captureException(error);

export const OffersSlim = (props: OffersSlimProps) => <SharedOffersSlim {...props} onError={onError} />;
